/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import Toggle from 'app/components/common/ToggleControl.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import Combobox from 'react-widgets/Combobox';
import Dropzone from 'react-dropzone';
import PasswordField from 'app/components/common/PasswordField.jsx';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import DeleteModal from 'app/components/common/DeleteModal.jsx';
import ConfirmModal from 'app/components/common/ConfirmModal.jsx';
import * as _ from 'underscore';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import SocialLoginProvider from 'app/redux/Providers/SocialLoginProvider.jsx';
import Loading from 'app/components/common/Loading.jsx';
import * as appConstants from 'app/redux/constants.js';
import UserMessages from 'app/modules/UserMessageModule.js';
import { Breakpoint } from 'react-socks';
import axios from 'axios';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import { compose } from 'redux';

class Account extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			user: {},
			errors: null,
			isEditing: {
				avatar: false,
				email: false,
				login: false,
				password: false,
				organization: false,
				pause: false,
				timezone: false,
				prefs: false
			},
			timezones: [],
			dropzone: null,
			credID: '',
			username: '',
			showSocialOptions: false,
			passwordStrength: 0,
			currentModal: null,
			isAddingLogin: false,
			redirectOnPasswordUpdate: false
		};

		this.deleteAccount = this.deleteAccount.bind(this);
		this.onBeginEdit = this.onBeginEdit.bind(this);
		this.onCancelEdit = this.onCancelEdit.bind(this);
		this.onCancelSocialLoginUpdate = this.onCancelSocialLoginUpdate.bind(this);
		this._updateEditingState = this._updateEditingState.bind(this);
		this._resetEditingState = this._resetEditingState.bind(this);
		this.onUpdateField = this.onUpdateField.bind(this);
		this.onTimezoneUpdate = this.onTimezoneUpdate.bind(this);
		this.onMailOptionsUpdate = this.onMailOptionsUpdate.bind(this);
		this.updateUser = this.updateUser.bind(this);
		this.updatePassword = this.updatePassword.bind(this);
		this.updatePasswordValue = this.updatePasswordValue.bind(this);
		this.addSocialLogin = this.addSocialLogin.bind(this);
		this.saveSocialLogin = this.saveSocialLogin.bind(this);
		this.removeSocialLogin = this.removeSocialLogin.bind(this);
		this.onSocialRollover = this.onSocialRollover.bind(this);
		this.onSocialRollout = this.onSocialRollout.bind(this);
		this.resendEmailConfirmation = this.resendEmailConfirmation.bind(this);
		this.uploadAvatar = this.uploadAvatar.bind(this);
		this.resetAvatar = this.resetAvatar.bind(this);
		this.generateApiKey = this.generateApiKey.bind(this);
		this.togglePause = this.togglePause.bind(this);
		this.onToggleSocialLogin = this.onToggleSocialLogin.bind(this);
		this.convertClient = this.convertClient.bind(this);

		props.getSocialLogins();
		props.getTimezones();

	}

	static getDerivedStateFromProps(props, state) {
		let nextState = {},
			apiErrors = null,
			appErrors = null;

		if (props.app.userLoaded === true && _.isEmpty(state.user)) {
			nextState.user = props.user.detail;
		}

		apiErrors = props.getApiErrors([
			'USER_UPDATE',
			'USER_GENERATE_API_KEY',
			'USER_DELETE',
			'SOCIAL_LOGIN_CREATE',
			'SOCIAL_LOGIN_DELETE',
			'USER_DETACH_CLIENT'
		]);
		if (apiErrors.length) {
			nextState.errors = apiErrors;
		}

		appErrors = props.getAppErrors([
			'USER_UPDATE',
			'USER_GENERATE_API_KEY',
			'USER_DELETE',
			'SOCIAL_LOGIN_CREATE',
			'SOCIAL_LOGIN_DELETE'
		]);
		if (appErrors.length) {
			nextState.errors = appErrors;
		}

		return (Object.keys(nextState).length) ? nextState : null;

	}

	componentDidMount() {
		this.props.authReturnHandler.apply(this, [{
			path: '/account'
		}, (credID, username) => {
			this.props.resetAuthState();
			this.setState({
				credID,
				username
			});
		}]);

		if (this.props.router.location.hash.match("password")) {
			let isEditing = _.clone(this.state.isEditing),
				redirectOnPasswordUpdate = this.state.redirectOnPasswordUpdate;

			isEditing.password = true;
			if (this.props.user.detail.isClient !== undefined && this.props.user.detail.isClient === true) {
				redirectOnPasswordUpdate = true;
			}

			this.setState({
				isEditing,
				redirectOnPasswordUpdate
			});

		}

	}

	componentDidUpdate(prevProps, prevState) {
		let errors = [];

		if (prevProps.app.loading.USER_FETCH && this.props.app.loading.USER_FETCH === false) {
			let user = this.props.user.detail;

			if (user.timezone === '') {
				user.timezone = 'America/Los_Angeles';
			}

			this.setState({
				user
			});
		}

		// check if the user deleted their account
		if (prevProps.app.loading.USER_DELETE === true && this.props.app.loading.USER_DELETE === false) {
			window.location.replace(this.props.app.config.loginUrl);
		}

		if (prevProps.app.loading.SOCIAL_LOGIN_CREATE === true && this.props.app.loading.SOCIAL_LOGIN_CREATE === false) {
			this.setState({
				credID: ''
			});
			this._resetEditingState();
		}

		if (!_.isEqual(prevProps.user.detail, this.props.user.detail)) {
			this.setState({
				user: this.props.user.detail
			});
			if (this.state.redirectOnPasswordUpdate && this.props.user.detail.needsPassword === false) {
				this.props.router.navigate("/socials");
				return;
			}
			errors = this.props.getApiErrors(['USER_UPDATE']);
			if (errors.length === 0) {
				this._resetEditingState();
			}
		}

		if (prevProps.app.loading.USER_UPDATE === true && this.props.app.loading.USER_UPDATE === false) {
			errors = this.props.getApiErrors(['USER_UPDATE']);
			if (errors.length === 0) {
				if (this.state.user.resendEmailConf !== undefined) {
					this.props.addMessage(UserMessages.generateFlashMessage(UserMessages.user.resendEmailConfirmation, 'USER_UPDATE'));
					let nextUser = Object.assign({}, this.state.user);
					delete nextUser.resendEmailConf;
					this.setState({
						user: nextUser
					});
				} else {
					this.props.addMessage(UserMessages.generateFlashMessage(UserMessages.user.updated, 'USER_UPDATE'));
				}
			}
		}

		if (prevProps.app.loading.USER_DETACH_CLIENT === true && this.props.app.loading.USER_DETACH_CLIENT === false) {
			if (this.state.errors === null) {
				window.location.reload(true);
			}
		}

		errors = this.props.getApiErrors(['USER_GENERATE_API_KEY']);
		if (errors.length) {
			if (errors[0].errors.perms !== undefined) {
				this.props.showUpgradeModal(this.props.closeAllModals, null, errors, 'apikey');
				this.props.deleteApiError(['USER_GENERATE_API_KEY']);
			}
		}

	}

	deleteAccount(e) {

		let confirmAction = (e) => {
				e.preventDefault();
				this.props.deleteUser(this.state.user.id);
				this.props.closeAllModals(null);
			},
			cancelAction = (e) => {
				this.props.closeAllModals(null);
			},
			modal = (
				<DeleteModal
					modalCopy={"Are you sure you want to delete your account?"}
					cancelAction={cancelAction}
					confirmAction={confirmAction} />
			);

		e.preventDefault();

		this.props.addModal(modal);

	}

	onBeginEdit(e) {

		let section = e.currentTarget.dataset.section;

		this._updateEditingState(section, true);

	}

	onCancelEdit(e) {

		let section = e.currentTarget.dataset.section,
			user = this.state.user;

		this._updateEditingState(section, false);
		this.props.deleteAppError(['USER_UPDATE']);

		// reset the value
		user[section] = this.props.user.detail[section];

		if (section === 'password') {
			user.password = '';
		}

		this.setState({
			user
		});

	}

	onCancelSocialLoginUpdate(e) {

		this._resetEditingState();
		this.setState({
			credID: ''
		});

	}

	_updateEditingState(key, state) {

		let isEditing = this.state.isEditing;

		isEditing[key] = state;

		this.setState({
			isEditing: isEditing
		});

	}

	_resetEditingState() {

		let isEditing = this.state.isEditing;

		for (let key in isEditing) {
			isEditing[key] = false;
		}

		this.props.deleteAppError([appConstants.USER_UPDATE]);

		this.setState({
			isEditing: isEditing
		});

	}

	onUpdateField(e) {

		let field = e.currentTarget.dataset.field,
			value = e.currentTarget.value,
			user = this.state.user;

		user[field] = value;

		this.setState({
			user
		});

	}

	onTimezoneUpdate(timezone) {

		let user = this.state.user;

		user.timezone = timezone.id;

		this.setState({
			user
		});

	}

	onMailOptionsUpdate(e) {
		let constants = this.props.app.config.constants,
			newState = e.currentTarget.dataset.togglestate === "true" ? false : true,
			field = e.currentTarget.dataset.field,
			value = 0,
			user = this.state.user;

		switch (field) {
			case 'info':
				value = constants.MAIL_INFO;
				break;

			case 'alert':
				value = constants.MAIL_ALERT;
				break;

			case 'stats':
				value = constants.MAIL_STATS;
				break;

		}

		if (newState) {
			user.mailOpts = parseInt(user.mailOpts, 10) | value;
		} else {
			user.mailOpts = parseInt(user.mailOpts, 10) - value;
		}

		this.updateUser(e, user);

		this.setState({
			user: user
		});

	}

	updateUser(e) {

		let	updatedUser = _.clone(this.state.user);

		// if cred id is set, send it to create/replace a social login
		if (this.state.credID !== '') {
			updatedUser.credID = this.state.credID;
		}

		if (updatedUser.resendEmailConf === 1) {
			let user = this.state.user;
			user.resendEmailConf = 0;
			this.setState({
				user
			});
		}

		this.props.updateUser(updatedUser);

	}

	updatePassword(e) {

		let user = this.state.user,
			errors = {},
			field = 'password',
			error = '',
			constants = this.props.app.config.constants;

		// mirror regular validation errors so we can use the mixin
		errors.errors = {};
		errors.errors.validation = {};
		errors.errors.validation[field] = [];

		this.props.deleteAppError([appConstants.USER_UPDATE]);

		if (!user.password || user.password === '' || user.password.length < 8) {
			errors.errors.validation[field].push('Invalid password, must be at least 8 characters long');
		}

		if (errors.errors.validation[field].length > 0) {
			this.props.setAppError({
				type: appConstants.USER_UPDATE,
				error: errors
			});
		} else {
			this.updateUser();
		}

	}

	updatePasswordValue(password) {

		let user = this.state.user;

		user.password = password.password;


		this.setState({
			user,
			passwordStrength: password.strength
		});

	}

	addSocialLogin(e) {

        let serviceId = e.currentTarget.dataset.serviceid,
			url = "/remote/beginloginupdate?lsID=:lsId&state=:state&final=:final",
			date = new Date(),
			state = ['LOGIN', serviceId, date.getTime()].join("_"),
			constants = this.props.app.config.constants;

        e.preventDefault();
        e.stopPropagation();

		if (this.state.isAddingLogin) {
			return;
		}

		this.setState({
			isAddingLogin: true
		}, () => {
			url = url.replace(':lsId', serviceId);
			url = url.replace(':state', state);
			url = url.replace(':final', window.encodeURIComponent(window.location.href));
			window.location.assign(url);
		});

    }

	saveSocialLogin(e) {

		if (this.state.credID !== '' && typeof this.state.credID === "string") {
			let svcID = this.state.credID.split("_")[1];
			this.props.createSocialLogin({
				serviceID: svcID,
				credID: this.state.credID
			});
		}

	}

	removeSocialLogin(e) {

		let loginId = e.currentTarget.dataset.loginid;

		this.props.deleteSocialLogin(loginId);

	}

	onSocialRollover(e) {

		this.setState({
			showSocialOptions: true
		});

	}

	onSocialRollout(e) {

		this.setState({
			showSocialOptions: false
		});

	}

	onToggleSocialLogin(e) {

		this.setState({
			showSocialOptions: !this.state.showSocialOptions
		});

	}

	resendEmailConfirmation(e) {

		let user = this.state.user;

		e.preventDefault();

		user.resendEmailConf = 1;

		this.setState({
			user
		});
		this.updateUser();

	}

	uploadAvatar(acceptedFiles, rejectedFiles) {
		let formData = new FormData();

        if (rejectedFiles.length) {
            let errorMsgs = [];
            rejectedFiles.map(({ file, errors }) => {
                let errs = [];
                errors.map((e) => {
                    errs.push(e.message);
                });
                errorMsgs.push(`${file.name}\n${errs.join("\n")}`);
            });

            if (errorMsgs.length) {
				this.props.setAppError({
					type: appConstants.USER_UPDATE,
					error: errorMsgs.join(" ")
				});
            }
        }

        if (acceptedFiles.length) {
            formData.append('type', 'avatar');

			acceptedFiles.map((file) => {
				formData.append('pubID', this.state.user.id);
                formData.append('file', file);
            });

            axios({
                url: '/upload.php',
                method: 'POST',
                data: formData,
                headers: { "Content-type": "multipart/form-data" },
                withCredentials: true,
                responseType: 'json'
            })
            .then((response) => {
                this.props.getUser();
				this._updateEditingState('avatar', false);
            })
            .catch((error) => {
                if (error.response) {
                    let errorData = error.response.data.errors,
                        errorMsgs = [];

                    const extractErrors = (obj) => {
                        if (Object.keys(obj).length) {
                            Object.keys(obj).map((key) => {
                                if (typeof obj[key] === 'string') {
                                    errorMsgs.push(obj[key]);
                                } else if (Object.keys(obj[key])) {
                                    extractErrors(obj[key]);
                                }
                            });
                        }
                    };

                    extractErrors(errorData);

                    if (errorMsgs.length) {
						this.props.setAppError({
							type: appConstants.USER_UPDATE,
							error: errorMsgs.join(" ")
						});
                    }
                } else if (error.message) {
					this.props.setAppError({
						type: appConstants.USER_UPDATE,
						error: error.message
					});
                }

            });
        }
	}

	resetAvatar(e) {

		let user = this.state.user;

		e.preventDefault();

		user.resetAvatar = 1;

		this.setState({
			user
		});
		this.updateUser();

	}

	togglePause() {
		let user = this.state.user,
			constants = this.props.app.config.constants;

		if (parseInt(user.pauseButton, 10) === constants.PUB_PAUSE_OFF) {
			user.pauseButton = constants.PUB_PAUSE_USER;
		} else if (parseInt(user.pauseButton, 10) === constants.PUB_PAUSE_USER) {
			if (user.firstPullFlag === undefined) {
				user.firstPullFlag = constants.FIRSTPULL_SINGLE;
			}
			user.pauseButton = constants.PUB_PAUSE_OFF;
		}

		this.setState({
			user: user
		}, () => {
			this.props.updateUser(user);
		});

	}

	 generateApiKey(e) {

		e.preventDefault();

		this.props.getAPIKey(this.state.user.id);

	 }

	 convertClient(e) {

		 let confirmAction = (e) => {
 				e.preventDefault();
 				this.props.detachClient();
 				this.props.closeAllModals(null);
 			},
 			cancelAction = (e) => {
 				this.props.closeAllModals(null);
 			},
 			modal = (
 				<DeleteModal
 					modalCopy={"Are you sure you want to disconnect your account from " + this.props.user.detail.clientInfo.organization + "?"}
 					cancelAction={cancelAction}
					cancelLabel="Don't Disconnect"
 					confirmAction={confirmAction}
					confirmLabel="Disconnect" />
 			);

 		e.preventDefault();

 		this.props.addModal(modal);

	 }

	render() {
		let that = this,
			constants = this.props.app.config.constants,
			header = null,
			main = null,
			avatarBlock = null,
			socialAvatarOptions = [],
			emailStatus = null,
			emailBlock = null,
			emailRollover = null,
			socialBlock = null,
			socialRollover = null,
			pauseBlock = null,
			passwordBlock = null,
			timezoneBlock = null,
			apiBlock = null,
			gravatarOption = null,
			creditsBlock = null,
			validationButton = null,
			organizationBlock = null,
			prefsActive = {
				info: (parseInt(this.state.user.mailOpts, 10) & constants.MAIL_INFO) ? true : false,
				alert: (parseInt(this.state.user.mailOpts, 10) & constants.MAIL_ALERT) ? true : false,
				stats: (parseInt(this.state.user.mailOpts, 10) & constants.MAIL_STATS) ? true : false
			},
			email = (this.state.user && this.state.user.email) ? this.state.user.email : '',
			organization = (this.state.user && this.state.user.organization) ? this.state.user.organization : '',
			confirmPause = () => {
				let cancel = () => {
						this.props.closeAllModals();
					},
					confirm = () => {
						this.togglePause();
						this.props.closeAllModals();
					},
					modal = (
						<ConfirmModal
							modalCopy="Are you sure you want to pause your account and stop all posting?"
							cancelAction={cancel}
							confirmAction={confirm}/>
					);

				this.props.addModal(modal);

			},
			{children, otherProps} = this.props;

		header = (
			<div className="account-header">
				Your Account Information
			</div>
		);

		if (this.props.app.userLoaded === false) {
			return (
				<Loading/>
			);
		}

		if (this.state.isEditing.avatar) {
			if (this.state.user.avatar.match('gravatar')) {
				gravatarOption = (<span>Edit your <a href="https://gravatar.com" target="_blank">Gravatar profile</a></span>);
			} else {
				gravatarOption = (
					<div className="gravatar-options left">
						<div className="use-gravatar" onClick={this.resetAvatar} role='button' aria-label="reset gravatar">
							Use your gravatar <img src={"https://secure.gravatar.com/avatar/" + this.state.user.emailHash + "?d=mm&s=40"}/>
						</div>
						<div className="gravatar-edit">
							Or <a href="https://gravatar.com" target="_blank">edit your gravatar first</a>
						</div>
					</div>
				);
			}

			avatarBlock = (
				<div>
					<div className="edit-block avatar">
						<div className="nav-user-image">
							<img src={this.state.user.avatar} className="user-img"/>
						</div>
						<div className="avatar-editing-options">
							<div className="gravatar-options">
								{gravatarOption}
							</div>
							<div className="avatar-uploader">
								<Dropzone
			                        accept={'image/jpeg, image/png, image/gif'}
			                        maxFiles={1}
			                        maxSize={2000000}
			                        onDrop={this.uploadAvatar}>
			                        {({ getRootProps, getInputProps }) => (
			                            <div {...getRootProps()} className="dlvr-image-picker">
			                                <input {...getInputProps()}/>
											<p>Upload an avatar: 2MB or less</p>
			                            </div>
			                        )}
			                    </Dropzone>
							</div>
						</div>
						<div className="buttons avatar">
							<div className="cancel-button" onClick={this.onCancelEdit} data-section="avatar" role='button' aria-label="cancel avatar edit">
								cancel
							</div>
						</div>
					</div>
				</div>
			);
		} else {
			avatarBlock = (
				<div className="display-block">
					<div className="account-display">
						<div className="nav-user-image">
							<img src={this.state.user.avatar} className="user-img"/>
						</div>
					</div>
					<div className="edit-button" onClick={this.onBeginEdit} data-section="avatar" role='button' aria-label="edit avatar">
						<i className="fa fa-pencil"></i>
					</div>
				</div>
			);
		}

		if (parseInt(this.state.user.bounceCount, 10) > 0) {
			emailStatus = (
				<div className="email-status right">
					<i className="fa fa-exclamation-triangle bouncing"></i>
					<span className="resend-conf" title="Click to re-verify" onClick={this.resendEmailConfirmation} role='button' aria-label="reverify email">Your emails have been bouncing. Update your email address or click here to re-verify</span>
				</div>
			);
			validationButton = (
				<div className="email-status validation-button">
					<div className="resend-validation" onClick={this.resendEmailConfirmation} role='button' aria-label="resend confirmation email">
						Resend Email Verification
					</div>
				</div>
			);
		} else {
			if (parseInt(this.state.user.emailActive, 10) === 1) {
				emailStatus = (
					<div className="email-status right">
						<i className="fa fa-check-circle verified"></i>
						<span className="status-label">verified</span>
					</div>
				);
			} else {
				emailStatus = (
					<div className="email-status right">
						<i className="fa fa-exclamation-circle unverified"></i>
						<span className="resend-conf" title="Click to send verification" onClick={this.resendEmailConfirmation} role='button' aria-label="resend confirmation email">unverified</span>
					</div>
				);
				validationButton = (
					<div className="email-status validation-button">
						<div className="resend-validation" onClick={this.resendEmailConfirmation}  role='button' aria-label="resend verification email">
							Resend Email Verification
						</div>
					</div>
				);
			}
		}

		if (this.state.isEditing.email) {
			emailBlock = (
				<div>
					<ErrorModule
	                    app={this.props.app}
	                    keys={['USER_UPDATE']}
	                    render={(state) => {
	                        return (
	                            <FieldError field="email" errors={state.errors}/>
	                        );
	                    }}/>
					<div className="edit-block">
						<UncontrolledTextInput
							className="text-input large"
							defaultValue={email}
							onChange={FormUtilityMixin.requestChange.bind(this)}
							data-field="user.email"/>
					</div>
					<div className="buttons">
						<div className="cancel-button" onClick={this.onCancelEdit} data-section="email" role='button' aria-label="cancel email edit">
							cancel
						</div>
						<div className="edit-save" onClick={this.updateUser} data-section="email" role='button' aria-label="save email edit">
							save
						</div>
					</div>
				</div>
			);
		} else {
			emailBlock = (
				<div className="display-block">
					<div className="account-display">
						{this.state.user.email}
					</div>
					<div className="edit-button" onClick={this.onBeginEdit} data-section="email" role='button' aria-label="edit email">
						<i className="fa fa-pencil"></i>
					</div>
				</div>
			);
		}

		if (this.state.isEditing.organization) {
			organizationBlock = (
				<div>
					<ErrorModule
	                    app={this.props.app}
	                    keys={['USER_UPDATE']}
	                    render={(state) => {
	                        return (
	                            <FieldError field="organization" errors={state.errors}/>
	                        );
	                    }}/>
					<div className="edit-block">
						<UncontrolledTextInput
							className="text-input large"
							defaultValue={organization}
							onChange={FormUtilityMixin.requestChange.bind(this)}
							data-field="user.organization"/>
					</div>
					<div className="buttons">
						<div className="cancel-button" onClick={this.onCancelEdit} data-section="organization" role='button' aria-label="cancel organization edit">
							cancel
						</div>
						<div className="edit-save" onClick={this.updateUser} data-section="organization" role='button' aria-label="save organization edit">
							save
						</div>
					</div>
				</div>
			);
		} else {
			organizationBlock = (
				<div className="display-block">
					<div className="account-display">
						{(organization !== "") ? organization : 'None set'}
					</div>
					<div className="edit-button" onClick={this.onBeginEdit} data-section="organization" role='button' aria-label="edit organization">
						<i className="fa fa-pencil"></i>
					</div>
				</div>
			);
		}

		if (this.state.showSocialOptions) {
			socialRollover = (
				<div className="social-rollover">
					<div className="social-option" data-serviceid={constants.LOGIN_SVC_FACEBOOK} onClick={this.addSocialLogin} role='button' aria-label="add facebook login">
						<IconFactory.facebook large={true}/>
					</div>
					<div className="social-option" data-serviceid={constants.LOGIN_SVC_TWITTER} onClick={this.addSocialLogin} role='button' aria-label="add x (twitter) login">
						<IconFactory.x large={true}/>
					</div>
					<div className="social-option" data-serviceid={constants.LOGIN_SVC_GOOGLE} onClick={this.addSocialLogin} role='button' aria-label="add google login">
						<IconFactory.google alt="login" large={true}/>
					</div>
				</div>
			);
		}


		// connecting or replacing a social login
		if (this.state.credID !== '' && typeof this.state.credID === "string") {
			let svc = this.state.credID.split("_")[1];
			let Icon = IconFactory[ConstantMixin.getIconIndexByCode(svc, 'login')];
			socialBlock = (
				<div>
					<ErrorModule
	                    app={this.props.app}
	                    keys={['SOCIAL_LOGIN_CREATE']}
	                    render={(state) => {
	                        return (
								<div>
	                            	<FieldError field="credID" errors={state.errors}/>
	                            	<FieldError field="serviceID" errors={state.errors}/>
								</div>
	                        );
	                    }}/>
					<div className="edit-block">
						<div className="social-login-item">
							<div className="login-icon">
								<Icon alt="login"/>
							</div>
							<div className="login-name">
								{this.state.username}
							</div>
						</div>
					</div>
					<div className="buttons">
						<div className="cancel-button" onClick={this.onCancelSocialLoginUpdate} data-section="social" role='button' aria-label="cancel social login edit">
							cancel
						</div>
						<div className="edit-save" onClick={this.saveSocialLogin} data-section="social" role='button' aria-label="save social login edit">
							save
						</div>
					</div>
				</div>
			);
		} else if (this.props.socialLogins.length) {
			socialBlock = (
				<div className="display-block">
					<ul className="social-login-list">
						{this.props.socialLogins.map(function(login, i){
							let Icon = IconFactory[ConstantMixin.getIconIndexByCode(login.serviceID, 'login')];
							return (
								<li key={i} className="social-login-item">
									<div className="login-icon">
										<Icon alt="login"/>
									</div>
									<div className="login-name">{login.userName}</div>
									<div className="login-controls" onClick={this.removeSocialLogin} data-loginid={login.ls_id}  role='button' aria-label="remove social login">
										<i className="fa fa-remove"></i>
									</div>
								</li>
							);
						}, this)}
						<li className="social-login-item social-rollover-wrapper left" onTouchStart={this.onSocialRollover} onMouseEnter={this.onSocialRollover} onMouseLeave={this.onSocialRollout}>
							<div className="login-icon">
								<i className="fa fa-plus-square new-login"></i>
							</div>
							<div className="new-login-label">
								Login with a different account
							</div>
							{socialRollover}
						</li>
					</ul>
				</div>
			);
		} else {
			socialBlock = (
				<div className="social-login-item social-rollover-wrapper left" onTouchEnd={this.onToggleSocialLogin} onMouseEnter={this.onSocialRollover} onMouseLeave={this.onSocialRollout}>
					<div className="login-icon">
						<i className="fa fa-plus-square new-login"></i>
					</div>
					<div className="new-login-label">
						Login using a social account
					</div>
					{socialRollover}
				</div>
			);
		}

		if (this.state.isEditing.pause) {
			let firstPullOptions = [
		            {value: constants.FIRSTPULL_SINGLE, label: 'Post the most recent items now'},
		            {value: constants.FIRSTPULL_OFF, label: 'Post when new items are published'},
		            {value: constants.FIRSTPULL_ON, label: 'Post all items (up to max)'},
		        ],
				value = (this.state.user.firstPullFlag === undefined || this.state.user.firstPullFlag) ? constants.FIRSTPULL_SINGLE : this.state.user.firstPullFlag;

			pauseBlock = (
				<div>
					<div>
						<StyledSelect
	                        options={firstPullOptions}
	                        linkedField={"user.firstPullFlag"}
	                        value={value}
	                        selectClass="large pause-first-pull"
	                        onChange={FormUtilityMixin.requestChange.bind(this)}/>
					</div>
					<button className="btn-primary active pause-button" onClick={this.togglePause} data-section="pause">
						Confirm to Resume Posting
					</button>
				</div>
			);
		} else {
			let pauseButton = null,
				pauseCopy = null;

			if (parseInt(this.state.user.pauseButton, 10) === constants.PUB_PAUSE_OFF) {
				pauseCopy = (
					<div className="pause-status">Posting: <span className="posting-active">Active</span></div>
				);
				pauseButton = (
					<button className="btn-primary active pause-button" onClick={confirmPause}>
						Pause All Posting
					</button>
				);
			} else if (parseInt(this.state.user.pauseButton, 10) === constants.PUB_PAUSE_USER) {
				pauseCopy = (
					<div className="pause-status">Posting: <span className="posting-paused">Paused</span></div>
				);
				pauseButton = (
					<button className="btn-primary active pause-button" onClick={this.onBeginEdit} data-section="pause">
						Resume All Posting
					</button>
				);
			}

			pauseBlock = (
				<div>
					{pauseCopy}
					{pauseButton}
				</div>
			);
		}

		if (this.state.isEditing.password) {
			passwordBlock = (
				<div>
					<ErrorModule
	                    app={this.props.app}
	                    keys={['USER_UPDATE']}
	                    render={(state) => {
	                        return (
								<div>
	                            	<FieldError field="password" errors={state.errors}/>
								</div>
	                        );
	                    }}/>
					<div className="edit-block password">
						<div className="account-display">
							<div>Create a New Password</div>
							<div className="password-block">
								<PasswordField
			                        inputProps={{
			                            id: "changePassword",
			                            name: "change-password",
										className: "text-input large"
			                        }}
			                        changeCallback={this.updatePasswordValue}
			                        minLength={7}
			                        minScore={2} />
							</div>
						</div>
					</div>
					<div className="buttons">
						<div className="cancel-button" onClick={this.onCancelEdit} data-section="password" role='button' aria-label="cancel password edit">
							cancel
						</div>
						<div className="edit-save" onClick={this.updatePassword} role='button' aria-label="save password edit">
							save
						</div>
					</div>
				</div>
			);
		} else {
			passwordBlock = (
				<div className="display-block">
					<div className="account-display" onClick={this.onBeginEdit} data-section="password" role='button' aria-label="edit password">
						Change your password
					</div>
					<div className="edit-button" onClick={this.onBeginEdit} data-section="password" role='button' aria-label="edit password">
						<i className="fa fa-pencil"></i>
					</div>
				</div>
			);
		}

		if (this.state.isEditing.timezone) {
			timezoneBlock = (
				<div>
					<div className="edit-block">
						<Combobox
							data={this.props.utilities.timezones}
							value={this.state.user.timezone}
							dataKey="id"
							textField="name"
							onChange={this.onTimezoneUpdate}
							data-field="timezone"
							filter="contains" />

					</div>
					<div className="buttons">
						<div className="cancel-button" onClick={this.onCancelEdit} data-section="timezone" role='button' aria-label="cancel timezone edit">
							cancel
						</div>
						<div className="edit-save" onClick={this.updateUser} role='button' aria-label="save timezone edit">
							save
						</div>
					</div>
				</div>
			);
		} else {
			timezoneBlock = (
				<div className="display-block">
					<div className="account-display">
						{this.state.user.timezone}
					</div>
					<div className="edit-button" onClick={this.onBeginEdit} data-section="timezone" role='button' aria-label="edit timezone">
						<i className="fa fa-pencil"></i>
					</div>
				</div>
			);
		}

		if (this.state.user.apiKeys && this.state.user.apiKeys.length) {
			apiBlock = (
				<div className="display-block">
					<div className="account-display">
						{this.state.user.apiKeys}
					</div>
					<div className="edit-button">
						<button className="btn-primary reverse-fixed" onClick={this.generateApiKey}>
							Regenerate Key
						</button>
					</div>
				</div>
			);
		} else {
			apiBlock = (
				<div className="display-block">
					<div className="account-display">
						No Api Key associated with this account
					</div>
					<div className="edit-button">
						<button className="btn-primary reverse-fixed" onClick={this.generateApiKey}>
							Generate Key
						</button>
					</div>
				</div>
			);
		}

		main = (
			<div className="editor-panel alt">
				<fieldset className="alt">
					<legend>Avatar</legend>
					{avatarBlock}
				</fieldset>
				<fieldset className="alt">
					<Breakpoint desktop only>
						<legend>Email{emailStatus}</legend>
						{validationButton}
						{emailBlock}
					</Breakpoint>
					<Breakpoint mobile only>
						<legend>Email</legend>
						{emailStatus}
						{validationButton}
						{emailBlock}
					</Breakpoint>
				</fieldset>
				{(this.props.appName === "dlvr") ? (
					<fieldset className="alt">
						<legend>Social Login</legend>
						{socialBlock}
					</fieldset>
				): null}
				<fieldset id="password" className="alt">
					<legend>Password Login</legend>
					{passwordBlock}
				</fieldset>
				{(this.props.appName === "dlvr") ? (
					<fieldset className="alt">
						<legend>Organization Name</legend>
						{organizationBlock}
					</fieldset>
				) : null}
				{(this.props.appName === "dlvr") ? (
					<fieldset className="alt">
						<legend>Master Posting Control</legend>
						{pauseBlock}
					</fieldset>
				) : null}
				{(this.props.appName === "dlvr") ? (
					<fieldset className="alt">
						<legend>Timezone</legend>
						{timezoneBlock}
					</fieldset>
				) : null}
				{creditsBlock}
				{(this.props.appName === "dlvr") ? (
					<fieldset className="alt">
						<legend>Email Preferences</legend>
						<div className="email-preference">
							<Toggle
								active={prefsActive.info}
								callback={this.onMailOptionsUpdate}
								linkedField="info"
								activeLabel="dlvr.it's Inside View - Get updates on new features, tips and the latest happenings at dlvr.it."
								inactiveLabel="dlvr.it's Inside View - Get updates on new features, tips and the latest happenings at dlvr.it."
								labelPlacement="right" />
						</div>
						<div className="email-preference">
							<Toggle
								active={prefsActive.alert}
								callback={this.onMailOptionsUpdate}
								linkedField="alert"
								activeLabel="Service Alerts - Be notified when there is a problem with one of your feeds or destinations."
								inactiveLabel="Service Alerts - Be notified when there is a problem with one of your feeds or destinations."
								labelPlacement="right" />
						</div>
						<div className="email-preference">
							<Toggle
								active={prefsActive.stats}
								callback={this.onMailOptionsUpdate}
								linkedField="stats"
								activeLabel="Stats Emails - Get a quick look at how many people are seeing your content."
								inactiveLabel="Stats Emails - Get a quick look at how many people are seeing your content."
								labelPlacement="right" />
						</div>
					</fieldset>
				) : null}
				{(this.props.appName === "dlvr") ? (
					<fieldset className="alt">
						<legend>Api Key</legend>
						{apiBlock}
					</fieldset>
				) : null}
				{(this.props.appName === "client") ? (
					<fieldset>
						<ErrorModule
		                    app={this.props.app}
		                    keys={['USER_DETACH_CLIENT']}
		                    render={(state) => {
		                        return (
		                            <FieldError field="detach" errors={state.errors}/>
		                        );
		                    }}/>
						<div className="alt">
							<p>Your social media profiles are managed by {this.props.user.detail.clientInfo.organization}</p>
							<button className="delete-button" onClick={this.convertClient}>
								Disconnect from {this.props.user.detail.clientInfo.organization}
							</button>
						</div>
					</fieldset>
				) : null }
				<fieldset>
					<div className="delete-block alt">
						<button className="delete-button" onClick={this.deleteAccount}>
							Delete Account
						</button>
					</div>
				</fieldset>
			</div>
		);

		return (
			<Content header={header} headerClass="white" main={main} modal={this.state.currentModal}/>
		);
	}
};

Account.displayName = "Account";

Account.propTypes = {
	context: PropTypes.string,
	appName: PropTypes.string
};

Account.defaultProps = {
	context: '',
	appName: "dlvr"
};

const enhance = compose(
	ComponentWithContext,
	SocialLoginProvider
);

export default enhance(Account);
